module.exports = __webpack_public_path__ + "media/metronic/_theme/media/demos/preview/demo2-11b153a17cbe8143ffab4d60aa90fa96.jpg";